<template>
	<div>
		<component :is="currentComponent" :msg="msg"></component>
	</div>
</template>

<script>
	import MsgAnalysisText from './MsgAnalysisText.vue'
	import MsgAnalysisImage from './MsgAnalysisImage.vue'
	import MsgAnalysisVoice from './MsgAnalysisVoice.vue'
	import MsgAnalysisVideo from './MsgAnalysisVideo.vue'
	import MsgAnalysisRed_package from './MsgAnalysisRed_package.vue'
	import MsgAnalysisTransfer_accounts from './MsgAnalysisTransfer_accounts.vue'
	import MsgAnalysisRed_package_d from './MsgAnalysisRed_package_d.vue'
	import MsgAnalysisTransfer_accounts_d from './MsgAnalysisTransfer_accounts_d.vue'
	import MsgAnalysisProgram from './MsgAnalysisProgram.vue'
	import MsgAnalysisLink from './MsgAnalysisLink.vue'
	import MsgAnalysisFinder from './MsgAnalysisFinder.vue'
	import MsgAnalysisFinder_live from './MsgAnalysisFinder_live.vue'
	import MsgAnalysisFile from './MsgAnalysisFile.vue'
	import MsgAnalysisPosition from './MsgAnalysisPosition.vue'
	import MsgAnalysisTransfer_accounts_r from './MsgAnalysisTransfer_accounts_r.vue'
	
	export default{
		name: 'MsgAnalysis',
		components:{
			MsgAnalysisText,
			MsgAnalysisImage,
			MsgAnalysisVoice,
			MsgAnalysisVideo,
			MsgAnalysisRed_package,
			MsgAnalysisTransfer_accounts,
			MsgAnalysisRed_package_d,
			MsgAnalysisTransfer_accounts_d,
			MsgAnalysisProgram,
			MsgAnalysisLink,
			MsgAnalysisFinder,
			MsgAnalysisFinder_live,
			MsgAnalysisFile,
			MsgAnalysisPosition,
			MsgAnalysisTransfer_accounts_r
		},
		props:{
			msg:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			}
		},
		data(){
			return {
				currentComponent: 'MsgAnalysisText'
			}
		},
		
		methods:{
			init(){
				let type = this.msg.type
				if(type === undefined){
					return
				}
				this.currentComponent = 'MsgAnalysis'+type.charAt(0).toUpperCase() + type.slice(1)
			}
		},
		created() {
			this.init()
		},
		
		
		watch:{
			msg(nVal){
				this.init()
			}
		}
	}
</script>

<style>
</style>
